<template>
  <div class="d-flex flex-column mt-2 justify-content-start" style="height: 100%">
    <!--  body div  -->
    <div class="flex-grow-1 mt-2 d-flex flex-column" style="height: 100%">
      <v-card rounded outlined class="d-flex flex-column flex" height="100%">
        <v-card-title>Document</v-card-title>
        <v-divider></v-divider>
        <!-- no longer using Table, using list to download each file, since its static -->
        <v-row justify="center" class="mx-4 mx-md-0">
          <v-col md="6">
            <v-card outlined rounded class="mt-6" >
              <v-alert outlined type="info" class="ma-4">Note: Not all documents are listed here</v-alert>
              <v-list dense >
                <document @download="admissionLetter">
                  <template v-slot:title>Admission letter</template>
                </document>
                <document @download="applicationSummary">
                  <template v-slot:title>Application summary</template>
                </document>
                <document>
                  <template v-slot:title>Application fee invoice</template>
                </document>
                <document>
                  <template v-slot:title>Screening fee invoice</template>
                </document>
                <document @download="screeningForm">
                  <template v-slot:title>Screening form</template>
                </document>
                <document v-for="(item, index) in documents" :key="index" @download="downloadDocument(item)">
                  <template v-slot:title>{{item.name}}</template>
                </document>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType"
                 v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>


<script>
import Api from '@/main/api';
import {mapGetters} from "vuex";
import LoadingDialog from '@ui/components/LoadingDialog.vue';
import MessageBox from '@ui/components/MessageBox.vue';
import ErrorResolver from "@/shared/ErrorResolver";
import Document from "@/student/components/documents/Document";

export default {
  name: "StudentDocument",
  components: {LoadingDialog, MessageBox, Document},
  data: () => ({
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    documents: []
  }),

  methods: {
    download(title, file){
      let fileURL = window.URL.createObjectURL(new Blob([file], {type: 'application/pdf'}));
      let filedense = document.createElement('a');

      filedense.href = fileURL;
      filedense.setAttribute('download', title + '.pdf');
      document.body.appendChild(filedense);

      filedense.click();
      filedense.remove();
    },

    admissionLetter() {
      const {registrationNumber} = this.getUser;
      this.loading = true;
      Api.admission.getLetter(registrationNumber).then(res => {
        this.download("admission", res.data)
      }).catch(err => ErrorResolver.checkErrors(this, err)).finally(() => this.loading = false)
    },

    applicationSummary() {
      const {registrationNumber} = this.getUser;
      this.loading = true;
      Api.applicants.applicationSummary(registrationNumber).then(res => {
        this.download("application-summary", res.data)
      }).catch(err => ErrorResolver.checkErrors(this, err)).finally(() => this.loading = false)
    },

    screeningForm() {
      const {registrationNumber} = this.getUser;
      this.loading = true;
      Api.applicants.screeningForm(registrationNumber).then(res => {
        this.download("screening-form", res.data)
      }).catch(err => ErrorResolver.checkErrors(this, err)).finally(() => this.loading = false)
    },

    fetchAllDocuments() {
      if(!this.getUser)
        return;

      this.loading = true;
      Api.portalDocument.all(this.getUser.programme.programmeType.id, 0, 100).then((res) => {
        this.documents = res.data.content.filter(e => e.programmeType != null);
      }).catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    },

    downloadDocument(item){
      this.loading = true;
      Api.portalDocument.download(item.link).then((res) => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
        let fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute("download",item.name + '.pdf');
        document.body.appendChild(fileLink);

        fileLink.click();
        fileLink.remove();
      }).catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => this.loading = false)
    }
  },

  computed: {//get the current user from store
    ...mapGetters(["getUser"])
  },

  watch: {
    getUser: function(val){
      if(val)
        this.fetchAllDocuments()
    }
  },

  created() {
    this.fetchAllDocuments()
  }
}
</script>


<style scoped>


</style>
